import React, { useEffect, useState } from "react";
// import HorizontalStepper from "./HorizontalStepper";
// import KycFormV2 from "./KycFormV2";
import { Button } from "../../../../shadcn/components/ui/button";
import { useDispatch } from "react-redux";
import {
  addBidderForEvent,
  alertAdminOnKYCIncomplete,
  deleteBidderForEvent,
  getBidderByUuid,
  getBidderOnboardingOfUser,
  getDigioKycStatus,
  initiateDigioKyc,
  updateBidderOnboardingDataAfterKYC,
  updateBidderForEvent,
} from "services/bidder";
// import * as axios from "axios";
// import { webStore, clearAuth } from "store";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import NameMismatchModal from "./NameMismatchModal";
import { setBidderOnboarding, setOnboarding } from "store";
import NameUpdateModal from "./NameUpdateModal";
import MobileMismatchFoundModal from "./components/MobileMismatchFoundModal";
import PaymentValidationApplicationForm from "./components/PaymentValidationApplicationForm";
import SwitchToOfflineKycModal from "./SwitchToOfflineKycModal";
import ErrorModal from "./components/IndividualBidders/ErrorModal";
import KYCRequestRedirectNotificationModal from "./components/IndividualBidders/KYCRequestRedirectNotificationModal";

interface IndividualKycWrapperProps {
  bidderUuid: any;
}

export default function IndividualKycWrapper({
  bidderUuid,
}: IndividualKycWrapperProps) {
  const dispatch = useDispatch();
  const router = useRouter();
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const [loading, setLoading] = useState(false);
  const [bidder, setBidder] = useState<any>(null);
  const [activeStep, setActiveStep] = useState<any>(0);
  const [checkingStatus, setCheckingStatus] = useState<any>(false);
  const [isKYCPending, setIsKYCPending] = useState<any>(false);
  const [waitForApproval, setWaitForApproval] = useState<any>(false);
  const [finalApprovalStatus, setFinalApprovalStatus] =
    useState<string>("pending");

  const [open, setOpen] = useState<any>(false);
  const [openNameModel, setOpenNameModel] = useState(false);
  const [redirectNotificationModelOpen, setRedirectNotificationModelOpen] =
    useState(false);
  const [nameMismatchObject, setNameMismatchObject] = useState<any>({
    profileName: onboardingData?.name,
    kycName: "",
    kycData: null,
  });

  const [errorModel, setErrorModel] = useState(false);
  const [mobileUpdatedFound, setMobileUpdatedFound] = useState(false);
  const [offlinePaymentValidation, setOfflinePaymentValidation] =
    useState(false);
  const [offlinePaymentValidationState, setOfflinePaymentValidationState] =
    useState("pending");
  const [switchingToOffline, setSwitchingToOffline] = useState(false);
  const [switchToOfflineModalOpen, setSwitchToOfflineModalOpen] =
    useState(false);

  const init = async (bidderUuid: any) => {
    setLoading(true);
    setCheckingStatus(true);
    setIsKYCPending(false);
    setWaitForApproval(false);
    setFinalApprovalStatus("pending");

    if (bidderUuid) {
      try {
        const data: any = await getBidderByUuid(bidderUuid);
        console.log("data: ", data?.payment_data);
        setBidder(data);
        if (
          process.env.NEXT_PUBLIC_ENABLE_ONLINE_DD_VALIDATION_FLOW === "true"
        ) {
          if (data?.meta?.enable_offline_payment_validation === true) {
            setOfflinePaymentValidation(true);
            if (data?.payment_data?.form_submission !== "submitted") {
              setOfflinePaymentValidationState("pending");
            } else {
              setOfflinePaymentValidationState("submitted");
            }
          }
        }

        setFinalApprovalStatus(data.status || "pending");
        if (data.digio_request_id) {
          // const kycReport = await postDataWithHeadersStatus();
          const payload = {
            bidder_onboarding_uuid: onboardingData.uuid,
            eligible_bidders_uuid: bidderUuid,
            kyc_request_id: data.digio_request_id,
            save_kyc_data_after_name_verification: true,
          };
          const kycReport: any = await getDigioKycStatus(payload);
          console.log("kycReport:=====>>>>>>> ", kycReport);
          if (
            data?.digio_request_id &&
            (kycReport?.status === "approved" ||
              kycReport?.status === "approval_pending")
          ) {
            setWaitForApproval(true);

            const digilockerAction = kycReport?.status_response?.actions?.find(
              (action: any) => action?.type === "digilocker",
            );
            let nameFetched =
              digilockerAction?.details?.pan?.name ||
              digilockerAction?.details?.aadhaar?.name ||
              kycReport?.kyc_data?.name;
            if (!digilockerAction?.details?.pan) {
              const ocrAction = kycReport?.status_response?.actions?.find(
                (action: any) => action?.action_ref === "id_proof-3",
              );
              nameFetched = ocrAction?.ocr_result?.name;
            }

            if (nameFetched !== onboardingData?.name) {
              await updateBidderForEvent({
                uuid: bidderUuid,
                meta: {
                  ...data?.meta,
                  name: nameFetched,
                },
                kyc_verified: true,
              });
            }
          } else if (
            data?.digio_request_id &&
            kycReport.status !== "approved"
          ) {
            setIsKYCPending(true);
            if (
              data?.digio_request_details?.customer_identifier &&
              onboardingData.mobile !==
                data?.digio_request_details?.customer_identifier
            ) {
              console.log("mobile change");
              setMobileUpdatedFound(true);
              setCheckingStatus(false);
              setLoading(false);
              return;
            }
            //
            const actions = kycReport?.status_response?.actions;
            if (actions && actions?.length > 0) {
              const evaluatedRules = actions?.filter(
                (action: any, index: number) => {
                  const conditionType =
                    action?.rules_data?.evaluated_rules?.[0]?.condition_type;
                  const result =
                    action?.rules_data?.evaluated_rules?.[0]?.outputs?.result;
                  return (
                    result === false && conditionType === "fuzzy_name_match"
                  );
                },
              );

              if (evaluatedRules && evaluatedRules?.length > 0) {
                const data =
                  evaluatedRules[0]?.rules_data?.evaluated_rules?.[0]?.inputs;
                if (data) {
                  setNameMismatchObject({
                    profileName: onboardingData?.name,
                    kycName: Object.entries(data)
                      .filter(([key, _]) => !key.includes("customer_name"))
                      .map(([_, value]) => value)[0],
                    isVerified: onboardingData?.user_can_update,
                  });
                  setOpen(true);
                }
              }
            }
          } else {
            console.log("KYC Not started");
          }
        }
      } catch (error) {
        setErrorModel(true);
        console.log("error: ", error);
      }
    }
    setCheckingStatus(false);
    setLoading(false);
  };

  useEffect(() => {
    init(bidderUuid);
  }, [bidderUuid, errorModel, activeStep]);

  useEffect(() => {
    const scriptId = "digio-sdk-script";

    // Check if script is already added
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.src = "https://app.digio.in/sdk/v11/digio.js";
      script.async = true;

      document.body.appendChild(script);
      console.log("SCRIPT__INJECTED");
      // Cleanup function
      return () => {
        const existingScript = document.getElementById(scriptId);
        if (existingScript) {
          console.log("called");
          document.body.removeChild(existingScript);
        }
      };
    }
  }, [checkingStatus, isKYCPending, errorModel]);

  // const postDataWithHeaders = async () => {
  //   try {
  //     const response = await axios.post(
  //       "http://localhost:3001/digio/initiate-kyc",
  //       {
  //         bidder_onboarding_uuid: "e5ac558c-a030-42a4-ba3f-22353a8dea9c",
  //         eligible_bidders_uuid: "62b18532-3bba-43b2-8772-c3fd5745b0bd",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${
  //             webStore.getState().bidderAuth?.accessToken
  //           }`,
  //         },
  //       }
  //     );

  //     return response.data;
  //   } catch (error) {
  //     console.error("Error:------", error);
  //   }
  // };

  // const postDataWithHeadersStatus = async () => {
  //   try {
  //     const response = await axios.post(
  //       "http://localhost:3001/digio/kyc-status",
  //       {
  //         bidder_onboarding_uuid: "e5ac558c-a030-42a4-ba3f-22353a8dea9c",
  //         eligible_bidders_uuid: "62b18532-3bba-43b2-8772-c3fd5745b0bd",
  //         kyc_request_id: "KID250404103931382ZFG69QQKLD8FFP",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${
  //             webStore.getState().bidderAuth?.accessToken
  //           }`,
  //         },
  //       }
  //     );
  //     console.log("response:---------->>>> ", response.data);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error:------", error);
  //   }
  // };

  const handleRequestSigningPopup = async () => {
    setRedirectNotificationModelOpen(true);
  };

  const handleRequestSigning = async () => {
    try {
      const res: any = await initiateDigioKyc({
        bidder_onboarding_uuid: onboardingData.uuid,
        eligible_bidders_uuid: bidderUuid,
      });
      // for local run
      // const res: any = await postDataWithHeaders();
      console.log("res:------ ", res, res.data.id);
      const digioEnvironment = process?.env?.NEXT_PUBLIC_DIGIO_ENVIRONMENT;
      var options = {
        environment: digioEnvironment,
        callback: async function (response: any) {
          if (response.hasOwnProperty("error_code")) {
            await alertAdminOnKYCIncomplete({
              bidder_onboarding_uuid: onboardingData.uuid,
              eligible_bidders_uuid: bidderUuid,
            });
          }
          console.log("response---------->>>>2", response);
          await init(bidderUuid);
        },
        logo: process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
          ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/24534319-e399-47f9-ad4c-f98d5d9bbbb3`
          : `${process.env.NEXT_PUBLIC_IMAGIX_URL}/fa4a3024-6d97-488b-88e0-a6f5d802b2ba`,
        is_redirection_approach: true,
        is_iframe: false,
        redirect_url: `${window.location.origin}/kyc/${bidderUuid}`,
        theme: {
          primaryColor: "#FF752C",
          secondaryColor: "#262626",
        },
      };
      // @ts-ignore
      var digio = new Digio(options);
      digio.init();
      const element: any = document.querySelector('[id^="wrapperdigio-ifm-"]');
      element?.classList?.add("custom-digio-style");
      digio.submit(
        res.data.id,
        res.data.customer_identifier,
        res.data?.access_token?.id,
      );
    } catch (error) {
      console.log("error: ", error);
      setErrorModel(true);
    }
  };

  const KYCPending = () => {
    return (
      <div className="flex items-center space-x-3 p-4 bg-yellow-100 border-l-4 border-yellow-500 rounded-md">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-6 h-6 text-yellow-600"
        >
          <circle
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeMiterlimit={10}
            cx={16}
            cy={16}
            r={12}
          />
          <rect x={15} y={14} width={2} height={8} fill="currentColor" />
          <rect x={15} y={10} width={2} height={2} fill="currentColor" />
        </svg>
        <p className="text-yellow-800 text-sm font-medium">
          Your auction participation process is incomplete.Please complete all
          the required steps to proceed.
        </p>
      </div>
    );
  };
  const KYCCheckingStatus = () => {
    return (
      <div className="flex items-center space-x-3 p-4 bg-blue-100 border-l-4 border-blue-500 rounded-md">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="w-6 h-6 text-blue-600 animate-spin"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            fill="currentColor"
            d="M12 2a10 10 0 0 0-9 6h2a8 8 0 1 1 7 10V22a10 10 0 0 0 0-20z"
          />
        </svg>
        <p className="text-blue-800 text-sm font-medium">
          Checking your auction participation application status. Please wait...
        </p>
      </div>
    );
  };
  const KYCApprovalPending = () => {
    return (
      <div className="flex items-center space-x-3 p-4 bg-green-100 border-l-4 border-green-500 rounded-md">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-6 h-6 text-green-600"
        >
          <circle
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeMiterlimit={10}
            cx={16}
            cy={16}
            r={12}
          />
          <rect x={15} y={14} width={2} height={8} fill="currentColor" />
          <rect x={15} y={10} width={2} height={2} fill="currentColor" />
        </svg>
        <p className="text-green-800 text-sm font-medium">
          Your auction participation application is currently under review by
          the bank. This process may take some time. Please check back later.
        </p>
      </div>
    );
  };
  const KYCApproved = () => {
    return (
      <div className="flex items-center space-x-3 p-4 bg-green-100 border-l-4 border-green-500 rounded-md">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-6 h-6 text-green-600"
        >
          <circle
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeMiterlimit={10}
            cx={16}
            cy={16}
            r={12}
          />
          <rect x={15} y={14} width={2} height={8} fill="currentColor" />
          <rect x={15} y={10} width={2} height={2} fill="currentColor" />
        </svg>
        <p className="text-green-800 text-sm font-medium">
          {`Your Application request has been approved by the banker. You can now view your event - ${bidder.meta.event_id}
          in the My Events section.`}
        </p>
      </div>
    );
  };
  const KYCApprovalRejected = () => {
    return (
      <div className="flex items-center space-x-3 px-8 py-8 bg-brand-lightOrange rounded-sm">
        <div>
          <p className="text-brand-textBlack text-base font-semibold pb-6">
            Application Rejected by Banker
          </p>
          <p className="text-yellow-800 text-xs font-medium">
            <span className="text-brand-textBlack font-semibold">
              Rejection Reason :
            </span>{" "}
            <span className="text-gray-500">{`${
              bidder?.remarks || "Rejected"
            }`}</span>
          </p>
          {/* <p className="text-yellow-800 text-sm font-medium">
            Your KYC needs to be completed again. Please visit the All Events
            section to re-participate in the auction.
          </p> */}
          <div className="flex justify-center lg:justify-start mt-8">
            <Button
              disabled={checkingStatus}
              onClick={handleRetryKycRequest}
              className="w-full max-w-[350px] mid:w-[300px]"
            >
              Initiate New Participation Request
            </Button>
          </div>
        </div>
      </div>
    );
  };
  const handleSwitchToOffline = async () => {
    if (switchingToOffline) return;

    setSwitchingToOffline(true);
    setSwitchToOfflineModalOpen(false);
    try {
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          bid_application_flow_mode: "offline",
        },
        kyc_verified: false,
        digio_request_status: "pending",
        kyc_data: {},
        digio_request_details: {},
        digio_kyc_data: {},
        digio_kyc_report: {},
      });
      // Reload the page to show offline KYC flow
      window.location.reload();
    } catch (error) {
      console.log("error switching to offline KYC: ", error);
      setSwitchingToOffline(false);
    }
  };

  const SwitchToOfflineKYCNotification = () => {
    return (
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-md mt-4">
        <div className="flex items-start sm:items-center space-x-3 flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5 sm:mt-0"
          >
            <path
              fill="currentColor"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
            />
          </svg>
          <div className="flex-1">
            <p className="text-blue-800 text-sm font-medium">
              Facing issues with Online KYC?
            </p>
            <p className="text-blue-700 text-xs mt-1">
              You can switch to Offline KYC mode by uploading your documents
              manually. Once done, fill out the auction participation form and
              submit it to the bank to complete your participation.
            </p>
          </div>
        </div>
        <Button
          onClick={() => setSwitchToOfflineModalOpen(true)}
          disabled={switchingToOffline}
          variant="outline"
          className="border-brand-headingBlue text-brand-headingBlue text-xs"
        >
          {switchingToOffline ? "Switching..." : "Switch to Offline Mode"}
        </Button>
      </div>
    );
  };
  // const filterKycDataBasedOnKycResponse = async () => {
  //   const digilocker = nameMismatchObject?.kycData?.find(
  //     (data: any) => data.action_ref === "digilocker-1"
  //   );
  //   const panIdData = nameMismatchObject?.kycData?.find(
  //     (data: any) => data.action_ref === "id_proof-1"
  //   );
  //   const ocrPanIdData = panIdData?.ocr_result;
  //   const panData = digilocker?.details?.pan;
  //   const aadharData = digilocker?.details?.aadhaar;
  //   const payload: any = {};
  //   if (digilocker) {
  //     if (digilocker && ocrPanIdData) {
  //       payload["name"] = ocrPanIdData?.ocr_result?.name;
  //       payload["authorized_person_name"] = ocrPanIdData?.ocr_result?.name;
  //     } else if (digilocker && panData) {
  //       payload["name"] = panData?.name;
  //       payload["authorized_person_name"] = panData?.name;
  //     }
  //     if (aadharData) {
  //       payload["full_address"] = aadharData?.permanent_address;
  //       payload["state"] = aadharData?.permanent_address_details?.state;
  //       payload["pin"] = aadharData?.permanent_address_details?.pincode;
  //       payload["aadhaar"] = aadharData.id_number;
  //       payload["user_can_update"] = false;
  //     }
  //     return payload;
  //   }
  //   return null;
  // };
  const handleProfileUpdate = async (updatedName: any) => {
    // const requestPayload = await filterKycDataBasedOnKycResponse();
    const requestPayload = {
      name: updatedName,
      authorized_person_name: updatedName,
      user_can_update: false,
    };

    if (requestPayload) {
      await updateBidderOnboardingDataAfterKYC({
        uuid: onboardingData?.uuid,
        payload: requestPayload,
      });
      await new Promise((resolve) => setTimeout(resolve, 500));
      const onboarding: any = await getBidderOnboardingOfUser(
        onboardingData?.user_uuid,
      );
      dispatch(setOnboarding(onboarding));
      dispatch(setBidderOnboarding(onboarding));
      await new Promise((resolve) => setTimeout(resolve, 250));
      await handleRetryKycRequest();
    }
    setOpen(false);
  };
  const handleRetryKycRequest = async () => {
    setCheckingStatus(true);
    await deleteBidderForEvent(bidderUuid);

    // await init(bidderUuid);
    // await handleRequestSigning();
    let payload: any = {
      email: onboardingData.email,
      name: onboardingData.name,
      mobile_number: onboardingData?.mobile,
    };

    payload["event_uuid"] = bidder.event_uuid;
    payload["status"] = "pending";
    payload["created_by"] = "user";
    payload["meta"] = {
      ...bidder.meta,
      is_re_kyc: true,
      user_details: {
        ...bidder?.meta?.user_details,
        mobile_number: onboardingData?.mobile,
        user_type: onboardingData?.type,
      },
    };
    const response: any = await addBidderForEvent(payload);
    setMobileUpdatedFound(false);
    console.log("response:======>>>> ", response);

    router.replace(`/kyc/${response.uuid}`).then(() => {
      setCheckingStatus(false);
      setOpen(false);
      setOpenNameModel(false);
    });
  };
  if (
    offlinePaymentValidation === true &&
    offlinePaymentValidationState === "pending"
  ) {
    return (
      <PaymentValidationApplicationForm
        bidder={bidder}
        bidderUuid={bidderUuid}
        init={init}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
      />
    );
  }
  // Check if bidder is in online mode
  const isOnlineMode = bidder?.meta?.bid_application_flow_mode === "online";
  const offlineEnabled =
    process.env.NEXT_PUBLIC_ENABLE_OFFLINE_INDIVIDUALS_KYC === "true";

  return (
    <div>
      {checkingStatus && <KYCCheckingStatus />}
      {!checkingStatus && isKYCPending && <KYCPending />}
      {offlineEnabled &&
        !checkingStatus &&
        isOnlineMode &&
        !waitForApproval && <SwitchToOfflineKYCNotification />}
      {!checkingStatus &&
        waitForApproval &&
        finalApprovalStatus !== "verified" &&
        finalApprovalStatus !== "rejected" && <KYCApprovalPending />}
      {!checkingStatus && finalApprovalStatus === "verified" && <KYCApproved />}
      {!checkingStatus && finalApprovalStatus === "rejected" && (
        <KYCApprovalRejected />
      )}
      {!checkingStatus && (
        <NameMismatchModal
          open={open}
          setOpen={setOpen}
          profileName={nameMismatchObject.profileName}
          kycName={nameMismatchObject.kycName || ""}
          userCanUpdate={onboardingData?.user_can_update || false}
          handleProfileUpdate={handleProfileUpdate}
          handleRetryKycRequest={handleRetryKycRequest}
        />
      )}
      {mobileUpdatedFound && (
        <MobileMismatchFoundModal
          open={mobileUpdatedFound}
          setOpen={setMobileUpdatedFound}
          handleRetryKycRequest={handleRetryKycRequest}
          profileMobile={onboardingData.mobile}
          applicationMobile={bidder?.digio_request_details?.customer_identifier}
        />
      )}
      {openNameModel && (
        <NameUpdateModal
          onboardingData={onboardingData}
          openNameModel={openNameModel}
          setOpenNameModel={setOpenNameModel}
          profileName={onboardingData?.name}
        />
      )}
      {offlineEnabled && switchToOfflineModalOpen && (
        <SwitchToOfflineKycModal
          open={switchToOfflineModalOpen}
          setOpen={setSwitchToOfflineModalOpen}
          handleConfirm={handleSwitchToOffline}
        />
      )}
      {finalApprovalStatus !== "rejected" && (
        <div className="py-4 px-8 bg-white rounded-lg mt-6">
          <p className="text-lg font-semibold text-gray-700">
            You need to complete Application to participate in the bidding
            process.
          </p>
          <p className="text-sm text-brand-textBlack mt-4 leading-relaxed">
            Please note that your profile name is{" "}
            <strong className="text-brand-orange">
              {onboardingData?.name}
            </strong>
            , and it must match the name on your official documents. If the
            document name does not match your profile name, your participation
            application will be rejected.
            {/* {onboardingData?.user_can_update && (
              <>
                <br />
                <span className="block mt-2">
                  You can update your profile name only once. Please make sure
                  to update it correctly before starting the KYC process.{" "}
                  <span
                    onClick={() => setOpenNameModel(true)}
                    className="text-[#1C64F2] underline cursor-pointer font-medium"
                  >
                    Click here to update.
                  </span>
                </span>
              </>
            )} */}
          </p>
          <div className="p-4">
            <p className="text-sm text-gray-600 mt-2">
              Please have the following details ready before starting the
              participation application process:
            </p>
            <ul className="mt-2 list-disc list-inside text-sm text-gray-600">
              <li>PAN Card</li>
              <li>Aadhaar Card</li>
              <li>Copy of EMD Payment</li>
              <li>Aadhaar linked to your mobile number</li>
            </ul>
            {/* <p className="text-sm text-gray-600 mt-2">
              Please do not close the participation step modal until the entire
              verification process is completed.
            </p> */}
            <div className="text-sm text-gray-600 mt-2">
              <p className="text-sm text-gray-600 mt-2">
                Please note that you are about to be redirected to our partner
                platform (Digio) to complete your KYC for participation. Make
                sure to complete all the steps until the verification process is
                finished — you’ll be automatically redirected back to this page
                once it’s done.
              </p>
            </div>

            <div className="flex justify-center lg:justify-start mt-12">
              <Button
                disabled={
                  checkingStatus ||
                  waitForApproval ||
                  finalApprovalStatus === "verified" ||
                  finalApprovalStatus === "rejected"
                }
                onClick={handleRequestSigningPopup}
                className="w-full max-w-[400px] mid:w-[400px]"
              >
                {isKYCPending
                  ? "Complete Pending Application"
                  : "Start Your Application process"}
              </Button>
            </div>
          </div>
        </div>
      )}
      {errorModel && (
        <ErrorModal open={errorModel} onClose={() => setErrorModel(false)} />
      )}
      {redirectNotificationModelOpen && (
        <KYCRequestRedirectNotificationModal
          open={redirectNotificationModelOpen}
          onClose={() => setRedirectNotificationModelOpen(false)}
          onConfirm={handleRequestSigning}
        />
      )}
    </div>
  );
}
